<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-price-updates">
        <i class="far fa-money-check-edit-alt"></i> Price Updates
      </Tab>
    </template>

    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-price-updates">
        <div class="row">
          <div class="col-lg-12">
            <DataTable :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="4" :url="processedDataURL" :filterOptions="filterOptions" :displayTools="true" :hasDateRangeFilter="true" :useQueryData="true" :displayExportTools="true" exportTitle="Price Updates">
              <template v-slot:title>
                <h3>Price Updates</h3>
              </template>
              <template v-slot:tools>
                <LinkButton type="new" href="/pricing/requests/priceupdate" v-if="userHasCreatePermission(PermissionTypes.PricingPermissionTypes.pricingApproval)" sizeClass="btn"> New Bulk Update</LinkButton>
              </template>
              <template v-slot:row="row">
                <tr :key="row.data.id">
                  <td class="table-data-nav-link">
                    <LinkPriceRequest :name="row.data.sequenceNumber ? '#'+row.data.sequenceNumber : 'Unknown'" :id="row.data.id" :newTab="false" />
                  </td>
                  <td>
                    {{row.data.reason}}
                  </td>
                  <td>
                    <LabelPriceRequestTypeBadge :type="row.data.type" />
                  </td>
                  <td>
                    <LabelPriceRequestStatusBadge :status="row.data.status" />
                  </td>
                  <td>{{row.data.createdAt | formatDateTime}}</td>
                  <td>{{row.data.approvalUpdatedDate | formatDateTime}}</td>
                  <td>
                    <LinkUser v-if="row.data.statusUser" :name="row.data.statusUser.name" :id="row.data.statusUser.id" />
                  </td>
                  <td>{{row.data.deniedReason}}</td>
                </tr>
              </template>
            </DataTable>
          </div>
        </div>
      </TabPage>

    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import form from '@/mixins/form'
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"
import StaticDataTable from '@/components/table/staticDataTable.vue'
import Utils from '@/utils/utils'

import LabelPriceRequestStatusBadge from '@/modules/pricing/components/labelPriceRequestStatusBadge'
import LabelPriceRequestTypeBadge from '@/modules/pricing/components/labelPriceRequestTypeBadge'

import { ApprovalTypes, ApprovalTypeLookup, PriceTypes, PriceRequestTypes, PriceRequestTypeLookup, PricingRequestStatusTypes, PricingRequestStatusTypeLookup } from '@/store/types'

export default {
  name: 'PriceRequestList',
  mixins: [form],
  components: {
    TabbedBox,
    Tab,
    TabPage,
    StaticDataTable,
    LabelPriceRequestStatusBadge,
    LabelPriceRequestTypeBadge
  },
  created() {
    this.ApprovalTypes = ApprovalTypes
    this.ApprovalTypeLookup = ApprovalTypeLookup
    this.PricingRequestStatusTypeLookup = PricingRequestStatusTypeLookup
  },
  mounted() {
  },
  data: () => {
    return {
      pendingRequestList: [],
      scheduledRequestList: [],
      columnList: [
        { title: "Number", data: "sequenceNumber" },
        { title: "Request Reason", data: "reason" },
        { title: "Type", data: "type" },
        { title: "Status", data: "status" },
        { title: "Request Date", data: "createdAt", dateFilter: true, type: 'datetime' },
        { title: "Approved/Denied Date", data: "approvalUpdatedDate", dateFilter: true, type: 'datetime' },
        { title: "Processed By", data: "statusUserId" },
        { title: "Denied Reason", data: "deniedReason" }
      ],
      filterOptions: [
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.draft), value: PricingRequestStatusTypes.draft, class: 'label-status-draft' },
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.generatingPriceLists), value: PricingRequestStatusTypes.generatingPriceLists, class: 'label-pricerequest-status-generatingPriceLists' },
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.pendingApproval), value: PricingRequestStatusTypes.pendingApproval, class: 'label-approval-pending' },
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.pendingSchedule), value: PricingRequestStatusTypes.pendingSchedule, class: 'label-status-pending' },
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.processing), value: PricingRequestStatusTypes.processing, class: 'label-status-processing' },
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.completed), value: PricingRequestStatusTypes.completed, class: 'label-status-completed' },
            { name: Utils.getLookupName(PricingRequestStatusTypeLookup, PricingRequestStatusTypes.cancelled), value: PricingRequestStatusTypes.cancelled, class: 'label-status-cancelled' }            
          ]
        },
        {
          field: 'type',
          name: 'Type',
          columnIndex: 1,
          options: [
            { name: Utils.getLookupName(PriceRequestTypeLookup, PriceRequestTypes.sales), value: PriceRequestTypes.sales, class: 'label-pricerequest-type-sales' },
            { name: Utils.getLookupName(PriceRequestTypeLookup, PriceRequestTypes.customer), value: PriceRequestTypes.customer, class: 'label-pricerequest-type-customer' },
            { name: Utils.getLookupName(PriceRequestTypeLookup, PriceRequestTypes.supplier), value: PriceRequestTypes.supplier, class: 'label-pricerequest-type-supplier' }
          ]
        }
      ]
    }
  },
  computed: {
    processedDataURL() {
      var params = {
      }
      return '/pricing/requests?' + $.param(params)
    }
  },
  methods: {
  }
}

</script>